import React, { PureComponent } from 'react';
import { Style } from 'radium';
import styles from './styles';

export default class AppStyles extends PureComponent {
  render() {
    return (
      <div>
        {Object.keys(styles).map(selector => {
          return <Style key={selector} scopeSelector={selector} rules={styles[selector]} />;
        })}
      </div>
    );
  }
}
